import { useState, useEffect } from "react";
const Services = ({ img, title, description }) => {
  return (
    <div className="col-3">
      <div className="text-center border shadow item">
        <div className="item-title">
          <img src={img} className="service-img" alt />
          <h5 className="mt-3 service-title">{title}</h5>
          <p className="text-secondary">{description}</p>
        </div>
        <div className="text-end p-2 ">
          <a href="#"> {/* <small>بیشتر بخوانید</small>{" "} */}</a>
        </div>
        <div className="bottom-line" />
      </div>
    </div>
  );
};

export default Services;
